import { isEqual } from "lodash";

import type { IPlainObject } from "app/pages/sales-intelligence/types/plainObject";

const removeFirstLevelEmptyValues = <T extends IPlainObject>(obj?: T | null): Partial<T> => {
    const nonNilObject = obj ?? {};

    const isEmptyValue = (value: unknown): boolean => {
        if (value === null || typeof value === "undefined") {
            return true;
        }

        if (Array.isArray(value)) {
            return value.length === 0;
        }

        //  TODO (SI-7226) uncomment when saved searches sanitization is implemented on BE (= no empty objects for no reason)
        // if (typeof value === "object") {
        //     return Object.keys(value).length === 0;
        // }

        return false;
    };

    return Object.entries(nonNilObject)
        .filter(([, value]) => !isEmptyValue(value))
        .reduce((acc, [key, value]) => {
            acc[key as keyof T] = value as T[keyof T];

            return acc;
        }, {} as Partial<T>);
};

export const hasFiltersDifference = <T extends IPlainObject>(
    outputFilters: Partial<T> | null | undefined,
    currentFilters: Partial<T> | null | undefined,
): boolean => {
    if (!outputFilters && !currentFilters) {
        return false;
    }

    const cleanedOutputFilters = removeFirstLevelEmptyValues(outputFilters);
    const cleanedCurrentFilters = removeFirstLevelEmptyValues(currentFilters);

    return !isEqual(cleanedOutputFilters, cleanedCurrentFilters);
};
